import { useCallback } from 'react';
import { useHostContext } from 'src/core/hooks/useHostContext';
import { UploadService } from 'src/core/services/upload/service';
export const useUploadFile = () => {
    const { token, product, subdomain } = useHostContext();
    const uploadFile = useCallback(async (file, entityType) => {
        const fileId = await UploadService.uploadFile({
            file,
            subdomain,
            entityType,
            accessToken: token,
            productId: product.id
        });
        const filePreviewUrl = await UploadService.getPreviewUrl(file);
        return { fileId, filePreviewUrl };
    }, [token, product.id, subdomain]);
    return { uploadFile };
};
